import React from 'react';
import { Link } from 'react-router-dom';
import { Printer, Stamp } from 'lucide-react';
import PageHeader from '@/components/shared/PageHeader';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const AccountingSettingsHomePage: React.FC = () => {
  return (
    <div className="w-full min-w-0 space-y-6">
      <PageHeader title="تنظیمات" description="مدیریت تنظیمات حسابداری" />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-base">
              <Printer className="h-4 w-4" />
              تنظیمات چاپ
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <p className="text-sm text-slate-600">
              تنظیم لوگو، QR، واترمارک و فوتر خروجی سندها.
            </p>
            <Button asChild variant="outline" className="w-full">
              <Link to="/accounting-settings/print">ورود به تنظیمات چاپ</Link>
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-base">
              <Stamp className="h-4 w-4" />
              چک و دسته‌چک
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <p className="text-sm text-slate-600">بارگذاری مهر و امضا برای نمایش روی دسته‌چک، ثبت برگه و چاپ بایگانی.</p>
            <Button asChild variant="outline" className="w-full">
              <Link to="/accounting-settings/cheque">مهر و امضا روی چک</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AccountingSettingsHomePage;
